import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  loadProductImages,
  searchUserProducts,
} from "../../services/UserProducts";
import { ListProduct } from "./ListProduct";
import Loading from "./Loading";

const RecommendedProducts = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  transform: translateY(-100%);
  height: min-content;
  z-index: 10;

  align-items: center;
  justify-content: center;
  background-color: #ecebebff;
  color: #131212ff;
`;

export default function RecommendedProductsSearch({
  isOpen,
  isAccountPremium,
  token,
  productName,
  onSelectProduct,
}) {
  const [userProductSearchResult, setUserProductSearchResult] = useState(null);
  const [isSearchingUserProduct, setIsSearchingUserProduct] = useState(false);

  useEffect(() => {
    let timeout;
    if (
      isOpen &&
      isAccountPremium &&
      productName &&
      productName.length >= 3 &&
      !productName.toLowerCase().includes("nome do produto")
    ) {
      setIsSearchingUserProduct(true);
      timeout = setTimeout(async () => {
        try {
          const result = await searchUserProducts(
            token,
            productName,
            0,
            5,
            null,
          );
          const loadedImages = await loadProductImages(token, result.products);
          setUserProductSearchResult({ ...result, products: loadedImages });
        } catch (e) {
          setUserProductSearchResult(null);
        }
        setIsSearchingUserProduct(false);
      }, 200);
    } else {
      setUserProductSearchResult(null);
      setIsSearchingUserProduct(false);
    }

    return () => clearTimeout(timeout);
  }, [isOpen, isAccountPremium, productName, token]);

  if (!isOpen || !isAccountPremium) return null;

  return (
    <RecommendedProducts
      className="list-products"
      // Keeps focus in the name input so blur doesn't unmount the box before a click lands.
      onMouseDown={(e) => e.preventDefault()}
    >
      {isSearchingUserProduct && (
        <Loading txt="Buscando..." color="#0a0a0aff" $NoBg absolute={false} />
      )}
      {userProductSearchResult &&
        !isSearchingUserProduct &&
        Array.isArray(userProductSearchResult.products) &&
        userProductSearchResult.products.map((p) => (
          <ListProduct
            key={p.id || p.name}
            product={p}
            showPromotion={false}
            action={() => onSelectProduct?.(p)}
          />
        ))}
    </RecommendedProducts>
  );
}
